import Modal from 'react-bootstrap/Modal';
import PrimaryButton from '../PrimaryButton';
import { Icon } from '@iconify/react';
import closeIcon from '@iconify/icons-material-symbols/close-rounded';
import styles from './CompletionReminderModal.module.scss';

interface Props {
  show: boolean;
  onDismiss: () => void;
  onMarkComplete: () => void;
}

const CompletionReminderModal = ({ show, onDismiss, onMarkComplete }: Props) => {
  const handleMarkComplete = () => {
    onMarkComplete();
    onDismiss();
  };

  return (
    <Modal
      centered
      show={show}
      onHide={onDismiss}
      className={styles.completionReminder}
      backdrop={true}
      keyboard={true}
      role='dialog'
      aria-labelledby='completion-reminder-title'
      aria-describedby='completion-reminder-description'
    >
      <div className={styles.cancelButtonContainer} onClick={onDismiss}>
        <Icon className={styles.cancelButton} icon={closeIcon} aria-label='Close' />
      </div>
      <div className={styles.content}>
        <h2 id='completion-reminder-title' className={styles.title}>
          <span className={styles.sparkle} aria-hidden='true'>
            ✨
          </span>{' '}
          All done? Let's check this off!
        </h2>
        <p id='completion-reminder-description' className={styles.description}>
          You've been here for a bit - click below to mark this lesson complete and keep your progress shining.
        </p>
      </div>
      <div className={styles.buttonContainer}>
        <PrimaryButton onClick={handleMarkComplete} className={styles.markCompleteButton}>
          Mark as Complete
        </PrimaryButton>
      </div>
    </Modal>
  );
};

export default CompletionReminderModal;
